import React, { useEffect, useState } from "react";
import OtherHero from "../../Components/Breadcrumb/OtherHero/OtherHero";
import { qhseBg } from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Qhse = () => {
  const { t } = useTranslation();

   const [settings, setSettings] = useState([]);
         
             useEffect(() => {
             getQhse();
             }, []); 
             
             async function getQhse() {
             try { 
               // API'den verileri çekiyoruz
               const response =  await axios.get('https://www.caspianrocksolutions.com/caspianrocksolutions/qhse.php');
               setSettings(response.data.data[0]);  // Gelen veriyi state'e kaydediyoruz
               console.log(response.data)
           
             } catch (error) {
               console.error('Error fetching categories:', error);  // Hata durumunda mesaj yazdırıyoruz
             }
             }

  return ( 
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <OtherHero
          title="QHSE"
          content="Quality I Healthy I Safety I Environment"
        />
      </div>
      <div className="bg-[#EDEDED] py-10 md:py-20 ">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex justify-between">
          <div>
            <p className="text-[28px] md:text-[44px] font-bold text-[#141615] font-firstFont">
             {settings.title}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {settings.content}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Qhse;
